<template>
  <transition name="showHeader">
    <div v-if="visible" class="header-animat">
      <a-layout-header
        v-if="visible"
        :class="[
          fixedHeader && 'ant-header-fixedHeader',
          sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed',
        ]"
        :style="{ padding: '0' }"
      >
        <div v-if="mode === 'sidemenu'" class="header">
          <MenuFoldIcon :collapsed="collapsed" @toggle="toggle" />
          <HeaderUserMenu @logout="Logout" />
        </div>
        <div v-else :class="['top-nav-header-index', theme]">
          <div class="header-index-wide">
            <slot name="left"></slot>
            <slot name="right"></slot>
          </div>
        </div>
      </a-layout-header>
    </div>
  </transition>
</template>

<script>
import { mixin } from '@/utils/mixin';
import { MenuFoldIcon } from '@/components/GlobalHeader/HeaderNavbar';
import HeaderUserMenu from '@/components/GlobalHeader/UserMenu';
import { mapActions } from 'vuex';

export default {
  name: 'GlobalHeader',
  components: {
    MenuFoldIcon,
    HeaderUserMenu,
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu',
    },
    menus: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    device: {
      type: String,
      required: false,
      default: 'desktop',
    },
  },
  data() {
    return {
      visible: true,
      oldScrollTop: 0,
    };
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  methods: {
    ...mapActions(['Logout']),
    handleScroll() {
      if (!this.autoHideHeader) {
        return;
      }

      const scrollTop =        document.body.scrollTop + document.documentElement.scrollTop;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimationFrame(() => {
          if (this.oldScrollTop > scrollTop) {
            this.visible = true;
          } else if (scrollTop > 300 && this.visible) {
            this.visible = false;
          } else if (scrollTop < 300 && !this.visible) {
            this.visible = true;
          }
          this.oldScrollTop = scrollTop;
          this.ticking = false;
        });
      }
    },
    toggle() {
      this.$emit('toggle');
    },
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style lang="less">
@ant-pro-prefix: ant-pro;
@ant-global-header-zindex: 105;

.header-animat {
  position: relative;
  z-index: @ant-global-header-zindex;
}
.showHeader-enter-active {
  transition: all 0.25s ease;
}
.showHeader-leave-active {
  transition: all 0.5s ease;
}
.showHeader-enter,
.showHeader-leave-to {
  opacity: 0;
}
</style>
